<template>
    <div>
        <mini-step class="f-topic-official-more-submit-content"
            :info="OfficialBoardLabel.AuditStaff"
            :has-padding="hasPadding">
            <!-- 审核人员分配 -->
            <staff-assign slot="options"
                :type="'officialaudit'"></staff-assign>
        </mini-step>

        <!-- 提交审核按钮 -->
        <div class="f-topic-official-more-submit-btn-wrapper"
            v-if="!isClosed && canOperateOfficial">
            <veui-button ui="primary"
                class="f-topic-official-more-submit-btn"
                @click="submit">
                {{submitOperationTip}}
            </veui-button>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/official-process-board.less';
</style>

<script>
import {mapState, mapGetters} from 'vuex';
import MiniStep from './MiniStep.vue';
import StaffAssign from './StaffAssign.vue';
import {Button} from 'veui';

export default {
    components: {
        'mini-step': MiniStep,
        'staff-assign': StaffAssign,
        'veui-button': Button
    },
    computed: {
        ...mapState({
            OfficialBoardLabel: state => state.topicContent.OfficialBoardLabel,
            showTips: state => state.topicContent.showTips,
            isCheckedNotRelatedIssue: state => state.topicContent.isCheckedNotRelatedIssue,
            officialinfo: state => state.topicContent.topicData.ext.qaOfficialInfo
        }),
        ...mapGetters([
            'canOperateOfficial',
            'isClosed',
            'isAuditPending',
            'submitOperationTip'
        ])
    },
    data() {
        return {
            hasPadding: true
        };
    },
    methods: {
        submit() {
            this.$emit('submit');
        },
        openConfirmWindow(infoTip, operationType) {
            this.$emit('openwindow', {infoTip, operationType});
        }
    }
};
</script>
